import { render } from "./GalleryImages.vue?vue&type=template&id=2f292624"
import script from "./GalleryImages.vue?vue&type=script&lang=js"
export * from "./GalleryImages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__